import React from 'react'
import { isEmpty } from 'lodash'

import { Box, Chip, Hidden, Paper, TablePagination } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { LoadingFeedback, NoData2 } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { ActionButtons } from './components'

import constants from 'constants/index'
import * as service from 'service'
import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'

import useStyles from './styles'

const KpiTable = () => {
  const classes = useStyles()

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { PRIORITIES } = constants.monitoringManagementKpi

  const { response, isLoading, refresh } = useFetch(
    service.dponet.monitoringManagementKpi.list,
    { perPage, page, includeRelations: true },
    [perPage, page],
  )

  const monitoringManagementKpis =
    response?.data?.monitoringManagementKpis || []

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Paper>
        {!isEmpty(monitoringManagementKpis) ? (
          <>
            <Box width="100%">
              <PerfectScrollbar
                options={{ wheelPropagation: false, useBothWheelAxes: true }}
              >
                <Table size="small" noWrap>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Nome</TableCell>
                      <TableCell>Departamento</TableCell>
                      <TableCell>Responsável</TableCell>
                      <TableCell>Prioridade</TableCell>
                      <TableCell>Prazo</TableCell>
                      <TableCell>Ativo</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {monitoringManagementKpis?.map(
                      (monitoringManagementKpi) => (
                        <TableRow key={monitoringManagementKpi?.id}>
                          <TableCell>{monitoringManagementKpi?.id}</TableCell>
                          <TableCell>{monitoringManagementKpi?.name}</TableCell>
                          <TableCell>
                            {monitoringManagementKpi?.department?.name}
                          </TableCell>
                          <TableCell>
                            {monitoringManagementKpi?.assignee?.name}
                          </TableCell>
                          <TableCell>
                            {PRIORITIES[monitoringManagementKpi?.priority]}
                          </TableCell>
                          <TableCell>
                            {helpers.formatters.date(
                              monitoringManagementKpi?.endDate,
                            ) || '-'}
                          </TableCell>
                          <TableCell>
                            <Chip
                              size="small"
                              className={
                                classes[
                                  monitoringManagementKpi?.active
                                    ? 'active'
                                    : 'inactive'
                                ]
                              }
                              label={
                                monitoringManagementKpi?.active
                                  ? 'Ativo'
                                  : 'Inativo'
                              }
                            />
                          </TableCell>
                          <TableCell align="right">
                            <ActionButtons
                              monitoringManagementKpi={monitoringManagementKpi}
                              refresh={refresh}
                            />
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              </PerfectScrollbar>
            </Box>
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </>
        ) : (
          !isLoading && <NoData2 title="Nenhum KPI encontrado." />
        )}
      </Paper>
    </>
  )
}

export default KpiTable
